module.exports = __webpack_public_path__ + "img/step-6.94f0c310.jpg";